import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';
import { ArrowRightIcon } from '@change/ds-icons/ArrowRightIcon';

import { Translate } from '@change-corgi/core-react/i18n';

import { useTagline } from './hooks';

export const Tagline: React.FC = () => {
	const {
		data: { learnMoreLinkHref },
		actions: { onLearnMoreClick },
	} = useTagline();

	return (
		<div className="mx-auto flex flex-col items-center gap-16 px-3 text-center lg:px-0">
			<Link
				trailingIcon={<ArrowRightIcon />}
				href={learnMoreLinkHref}
				onClick={onLearnMoreClick}
				data-qa="learn-more-link"
				variant="secondary"
			>
				<Translate value="corgi.homepage.hero_section.learn_more_link_alt" />
			</Link>
			<Text as="p" variant="heading" size="small" data-testid="homepage-hero-tagline">
				<Translate value="corgi.homepage.petition_marquee.title" />
			</Text>
		</div>
	);
};
